import React from "react";
import ProjectStep1 from "../Components/Step1";

const BasicDetails = ({
  RichText,
  projectDetails,
  setProjectDetails,
  setIsLoading,
  setSelectedTab,
  variables,
  assets,
  DynamicImage,
  submitCurrentStep,
  setSubmitCurrentStep,
  toast,
  useMutation,
  useQueryClient,
  useSession,
  getDirtyValues,
  mutateAction,
}: any) => {
  return (
    <ProjectStep1
      RichText={RichText}
      projectDetails={projectDetails}
      setProjectDetails={setProjectDetails}
      setIsLoading={setIsLoading}
      setSelectedTab={setSelectedTab}
      variables={variables}
      assets={assets}
      DynamicImage={DynamicImage}
      submitCurrentStep={submitCurrentStep}
      setSubmitCurrentStep={setSubmitCurrentStep}
      toast={toast}
      useMutation={useMutation}
      useQueryClient={useQueryClient}
      useSession={useSession}
      getDirtyValues={getDirtyValues}
      mutateAction={mutateAction}
    />
  );
};

export default BasicDetails;
